var React = require('react');

function GreenRightArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#39D965","fillRule":"evenodd","d":"M5.114.584c1.233.854 1.663 2.394 1.129 3.7L21 14.5 6.243 24.715c.533 1.307.104 2.847-1.13 3.701-1.453 1.006-3.472.68-4.51-.729-1.038-1.408-.701-3.366.751-4.371a3.317 3.317 0 0 1 3.98.166L18.309 14.5 5.333 5.52a3.318 3.318 0 0 1-3.979.166C-.098 4.678-.436 2.72.602 1.312 1.641-.096 3.66-.422 5.114.584z"}));
}

GreenRightArrow.defaultProps = {"width":"21","height":"29","viewBox":"0 0 21 29"};

module.exports = GreenRightArrow;

GreenRightArrow.default = GreenRightArrow;
